export default __webpack_public_path__ + "static/header-title-dont-light-d62b6dfe53de04d8dfd83067b5b28bf1.png";